import script from "./CInputCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./CInputCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./CInputCompetencies.vue?vue&type=style&index=0&id=555ebe88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555ebe88"]])

export default __exports__